import Overview from './overview.vue';
import Full from './full.vue';
import Detail from '@rebuild/materials/shared/report/Detail.vue';

export const componentMap = {
    overview: Overview,
    full: Full,
    detail: Detail
};
